<template>
  <div>
    <div>
      <div class="formPosition">
        <v-card style="margin: auto" width="1200">
          <v-card-title
            style="background-color: #006699; color: white"
          ></v-card-title>
          <v-progress-linear
            style="margin: 0 auto; height: 10px"
            :indeterminate="isLoading"
            v-show="isLoading"
          ></v-progress-linear>

          <v-row style="margin: 10px 0 4px 4px;">
            <v-col cols="4" md="3">
              <div class="tpaCombox">
                <v-combobox
                  v-model="anoLectivoSelected"
                  :items="Listaranoslectivo"
                  label="Filtrar por anolectivo"
                  item-value="anolectivo"
                  rounded
                  item-text="anolectivo"
                  @change="selecionarEmolumentos()"
                >
                </v-combobox>
              </div>
            </v-col>

            <v-col cols="4" md="2">
              <div class="tpaCombox">
                <v-combobox
                  v-model="classeSeleted"
                  label="Classe"
                  item-value="id"
                  item-text="descricao"
                  :items="ClassesAll"
                  return-object
                  @change="selecionarClasse()"
                  rounded
                >
                </v-combobox>
              </div>
            </v-col>

            <v-col cols="6" md="6">
              <v-row>
                <v-col cols="1" md="1">
                  <v-btn v-if="searchInDb" @click="initialize(searchInDb)" text icon color="green">
                      <v-icon>cached</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="11" md="11">
                  <v-text-field
                    v-model="searchInDb"
                    append-icon="search"
                    label="Pesquisar por turma"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headers"
            :items="turmasFiltered"
            :search="searchInDb"
            :items-per-page="8"
            sort-by="data_"
            class="elevation-3"
          >
          <template v-slot:item.index="{ item }">
                <span> {{ turmasFiltered.indexOf(item) + 1 }}</span>
              </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                fab
                color="#006699"
                @click="showDialogoDevedores(item)"
                style="color: white"
                small
                ><v-icon small>print</v-icon></v-btn
              >
            </template>
            <template v-slot:no-data>
              <!--   <v-btn color="primary" @click="initialize">Reset</v-btn>  -->
              Clica em + para adicionar novo estudante
            </template>
          </v-data-table>
        </v-card>

        <!-- ============================== DIALOGO Para salvar uma turma ====================== -->

        <template>
          <v-row>
            <v-dialog v-model="dialog" persistent max-width="600px">
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card>
                  <v-overlay :value="overlay">
                    <v-progress-circular
                      indeterminate
                      size="64"
                    ></v-progress-circular>
                  </v-overlay>
                  <v-card-title style="background-color: #006699; color: white">
                    <span class="text-h5">Seleção dos meses</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" md="12">
                          <label>Turma: </label
                          ><span style="font-size: 15px; font-weight: bold">{{
                            turma !== null ? turma.turma : ""
                          }}</span>
                        </v-col>
                        <v-col cols="12" md="12">
                          <label>Curso: </label
                          ><span style="font-size: 15px; font-weight: bold">{{
                            turma !== null ? turma.curso : ""
                          }}</span>
                          <hr />
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                          <v-combobox
                            :rules="ruleRequired"
                            :items="meses"
                            v-model="mesInicial"
                            item-text="descricao"
                            return-object
                            @change="setMeses()"
                            outlined
                            label="Mês Inicial"
                          ></v-combobox>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-combobox
                            :rules="ruleRequired"
                            v-model="mesFinal"
                            :items="meses"
                            item-text="descricao"
                            outlined
                            return-object
                            @change="setMeses()"
                            label="Mês Final"
                          ></v-combobox>
                        </v-col>
                      </v-row>
                    </v-container>
                    <span
                      v-if="
                        !(
                          mesInicial !== null &&
                          mesFinal !== null &&
                          mesFinal.id_mes >= mesInicial.id_mes
                        )
                      "
                      style="color: red; font-size: 15px"
                      >Att: </span
                    ><small
                      v-if="
                        !(
                          mesInicial !== null &&
                          mesFinal !== null &&
                          mesFinal.id_mes >= mesInicial.id_mes
                        )
                      "
                      style="font-size: 12px; font-weight: bold"
                      >Intervalo de meses incorrecto</small
                    ><br />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="black darken-1" text @click="dialog = false">
                      fechar
                    </v-btn>
                    <v-btn
                      color="green darken-1"
                      text
                      :disabled="
                        !valid ||
                        (mesInicial !== null &&
                          mesFinal !== null &&
                          mesInicial.id_mes > mesFinal.id_mes)
                      "
                      @click="Guardar()"
                    >
                      Gerar Lista
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>
          </v-row>
        </template>
        <!-- ===================================================================================== -->
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import Swal from "sweetalert2";
import axios from "../../plugins/axios";
const ls = require("local-storage");
export default {
  data: () => ({
    valid: true,
    classeSeleted: {
      id: 0,
      descricao: "Todos",
    },

    ClassesAll: [
      { id: 0, descricao: "Todos" },
      { id: 1, descricao: "10ª Classe" },
      { id: 2, descricao: "11ª Classe" },
      { id: 3, descricao: "12ª Classe" },
      { id: 4, descricao: "13ª Classe" },
    ],
    meses: [],
    headers: [
    { text: "#", value: "index" },
      {
        text: "Descrição",
        align: "left",
        sortable: false,
        value: "turma",
      },
      { text: "Curso", value: "curso" },
      { text: "Classe", value: "classe" },
      { text: "Número de estudante", value: "quantalunos" },
      { text: "Período", value: "turno" },
      { text: "Data criação", value: "data_" },
      { text: "Autor", value: "autor" },
      { text: "Ação", value: "action" },
    ],
    turmas: [],
    Listaranoslectivo:[],
    turmasFiltered: [],
    turma: null,
    classes: [],
    mesesLista: [],
    classesFiltered: [],
    searchInDb: "",
    cursos: [],
    periodos: [
      { id: "M", descricao: "Manhã" },
      { id: "T", descricao: "Tarde" },
      { id: "N", descricao: "Noite" },
    ],
    dialog: false,
    overlay: false,
    anolectivoSelected: null,
    mesInicial: null,
    mesFinal: null,
    turma_obj: {
      curso: "",
      classe: "",
      sala: "",
      periodo: "",
      descricao: "",
    },
    turma_objDefault: {
      curso: "",
      classe: "",
      sala: "",
      periodo: "",
      descricao: "",
    },
    ruleRequired: [(value) => !!value || "campo obrigatorio"],
  }),

  created() {
    this.initializeTurmas();
    this.ListarMeses();
    this.initializeAnosLectivo()
  },

  computed: {
    licencaExpirada() {
      return ls.get("licencaExpirada");
    },
    anolectivo() {
      return ls.get("anolectivo");
    },
    Integrado() {
      return ls.get("integrado") === "1";
    },
    licencaExpirada() {
      return ls.get("licencaExpirada");
    },
  },

  methods: {
    selecionarClasse() {
      if(this.classeSeleted.id == 0) {
        this.turmasFiltered = this.turmas;
      } else {
        this.turmasFiltered = this.turmas.filter((t) => t.idAno_Academico == this.classeSeleted.id);
      }
    },


    closeDialog() {
      this.dialog = false;
      this.turma_obj = this.turma_objDefault;
      this.$refs.form.resetValidation();
    },


    async initializeAnosLectivo() {
      this.isLoading = true;
      try {
        this.Listaranoslectivo = await axios.get("/listarAnoLectivoAllFinancas").then((res) => res.data);
      } catch (error) {
        Swal.fire("Informação", "<p>Erro ao carregar os anos lectivos!</p>", "error");
      } finally {
        this.isLoading = false;
      }
    },

    async selecionarEmolumentos () {
        this.initializeTurmasPorAnolectivo(this.anoLectivoSelected.anolectivo)
    },


    setMeses() {
      if (this.mesInicial !== null && this.mesFinal !== null) {
        this.mesesLista = [];
        for (
          let index = this.mesInicial.id_mes;
          index <= this.mesFinal.id_mes;
          index++
        ) {
          let object = this.meses.filter((m) => m.id_mes === index)[0];
          this.mesesLista.push({
            id: index,
            descricao: object.descricao,
            fkMes: object.fkMes,
          });
        }
      }
    },
    openDialog() {
      if (this.Integrado) {
        Swal.fire(
          "Integração",
          "<p>Para os sistemas integrados, as turmas são registrados no módulo de pedagogia.</p>",
          "warning"
        );
      } else {
        this.dialog = true;
      }
    },
    loadclasse() {
      this.classesFiltered = this.classes.filter(
        (c) => c.nivel === this.turma_obj.curso.nivel_ensino
      );
    },
    async initializeCursos() {
      try {
        this.isLoading = true;
        this.cursos = await axios.get("/cursoFindAll").then((res) => res.data);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    showDialogoDevedores(item) {
      this.turma = item;
      this.dialog = true;
    },
    async initializeTurmas() {
      try {
        this.isLoading = true;
        this.turmas = await axios.get("/turmasFindAlls").then((res) => res.data);
        this.turmasFiltered = this.turmas;
      } catch (error) {
        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.isLoading = false;
      }
    },


    async initializeTurmasPorAnolectivo( anolectivo ) {
      try {
        this.isLoading = true;
        this.overlay = true;
        this.turmas = await axios.get('/turmasFindAlls/'+anolectivo).then(res => res.data);
        this.turmasFiltered = this.turmas;
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro durante o carregamento das turmas!', 'error')
      } finally {
        this.overlay = false;
        this.isLoading = false;
      }
    },


    async ListarMeses() {
      try {
        this.progresso = true;
        this.meses = await axios.get("/ListarMeses").then((res) => res.data);
        this.progresso = false;
      } catch (error) {
        this.progresso = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    async ObterPrecoPropina(query) {
      try {
        return await axios.post("/obterValorMensalidade", query).then();
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro ao tentar carregar o preço de propina"
        );
      }
    },

    async EstudanteMesesPagosByQuery(query) {
      try {
        return await axios.post("/mesesPagosEstudanteByQuery", query).then();
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro ao tentar carregar os pagamentos"
        );
      }
    },

    async ListarEstudanteFromTurma(turma) {
      try {
        return await axios.get("/ListaEstudantes/" + turma).then();
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro ao tentar carregar os estudantes"
        );
      }
    },

    async ListarEstudanteFromTurmaGetNumeroMatricula(turma,anolectivo) {
      try {
        return await axios.get("/ListaEstudantesGetMatricula/" + turma+'/'+anolectivo).then();
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro ao tentar carregar os estudantes"
        );
      }
    },
    async Guardar() {
      if (this.licencaExpirada) {
        Swal.fire(
          "Informação",
          "A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!",
          "info"
        );
      } else {
        if (this.$refs.form.validate()) {
          try {
            this.overlay = true;
            ls.set("meses", this.mesesLista);
            ls.set("turma", this.turma);
            let estudantes = await this.ListarEstudanteFromTurma(
              this.turma.pkTurma
            ).then((res) => res.data);
            console.log(this.turma);
            let queryMesesPagos =
              await this.ListarEstudanteFromTurmaGetNumeroMatricula(
                this.turma.pkTurma,this.turma.anoLectivo
              ).then((res) => res.data);
            let mesesPagos = await this.EstudanteMesesPagosByQuery(
              queryMesesPagos
            ).then((res) => res.data);
            let precoPropina = await this.ObterPrecoPropina({
              curso: this.turma.idCurso,
              anoacademico: this.turma.idAno_Academico,
            }).then((res) => res.data);
            //let bolseiros = await helperFinancasService.GetBolseirosIgnabeAcaoSocial().then((res)=>res.data)
            ls.set("estudantes", estudantes);
            ls.set("mesespagos", mesesPagos);
            ls.set("precoPropina", precoPropina.length ? precoPropina : 0);
            ls.set("bolseiros", []);

            /*
              Esse trecho de código, imprimirRecibo(), carrega dinamicamente o componente de 
              uma segunda página chamada "recibo-pagamento-escola.vue" e o monta em uma instância 
              temporária do Vue. Isso permite que você exiba e imprima um recibo de pagamento da 
              escola sem interferir na página atual.
            */

            import("./devedoresPdf.vue").then((module) => {
              const SegundaPagina = module.default;
              const tempInstance = new Vue({
                render: (h) => h(SegundaPagina),
              });
              tempInstance.$mount();
            });

            //this.$router.push('gerar-devedores')
          } catch (error) {
            Swal.fire(
              "Informação",
              "Ocorreu um erro ao gerar a lista de devedores",
              "error"
            );
          } finally {
            this.overlay = false;
          }
        }
      }
    },
  },
};
</script>

<style>
.top_option_pagamentos {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.top_option_pagamentos .combox_containers {
  display: grid;
  grid-template-columns: 0.8fr 0.8fr 0.8fr;
  column-gap: 5px;
  margin-bottom: 5px;
}

.tpaCombox {
  height: 50px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0 5px;
}
</style>
